import NoDataPage from './NoDataPage';

export default NoDataPage;
